<template>
    <div class="search-form">
        <div style="padding-bottom: 10px;" v-if="dateSearh">
            <Select v-model="searhForm.riqitype" style="width:100px" @on-change="change">
                <Option v-for="item in selectList" :value="item.name" :key="item.name">{{ item.name }}</Option>
            </Select>
            <DatePicker :value="searhForm.riqi" format="yyyy-MM-dd" @on-change="change" type="daterange" style="width: 432px;margin-top: 10px;" placement="bottom-end" placeholder="选择日期范围" :clearable="false">
            </DatePicker>
        </div>
        <div v-for="(citem,index) in column" :key="index" class="box" v-if="!citem.hide && (!citem.vif || citem.vif())">
            <Select v-if="citem.type === 'select'" :multiple="citem.multi||citem.multiple" :value="citem.value" :style="`width:${citem.width || 200}px`" @on-change="selectChange(index,$event)" clearable :placeholder="citem.placeholder">
                <Option v-for="item in citem.options" :value="item.value===undefined?item.name:item.value" :key="item.name">
                    <div v-if="citem.code">
                        <div>{{item.name}}</div>
                        <div style="color:#ccc;font-size: 14px;" class="nowrap">{{item.code}}</div>
                    </div>
                    <div v-else>{{ item.name }}</div>
                </Option>
            </Select>
            <!-- <div style="position: relative;" v-else-if="citem.type === 'selectMultiple'">
              <Select  clearable multiple @mouseover.native="(citem.value && citem.value.length)? isDeleteButton=true : isDeleteButton=false"  :max-tag-count='1'  v-model.sync="citem.value" :placeholder="citem.placeholder" style="width:200px;" @on-change="change(index,$event)">
                  <Option v-for="(item,i) in citem.options" :value="item._id || item.name" :key="item.name+i">{{ item.name }}</Option>
              </Select>
              <span class="delete-selected-mu" v-show="isDeleteButton" @click.prevent="deleteButtonClick(index)">
                  <Icon type="ios-close-circle" size="14" color="#5C6B77" style="margin-left: 4px;" />
              </span>
            </div> -->
            <BaseSelect v-else-if="citem.type === 'selectSearch'" :value="citem.value || null" :options="citem.options.options" :multiple="citem.multi || citem.multiple || citem.options.multiple||citem.options.multi" :type="citem.options.type" :parameter="citem.options.parameter" :placeholder="citem.options.placeholder" @change="searchChange(index,$event)" @localSearchchange="searchChange(index,$event,'local')" />
            <DatePicker v-else-if="citem.type === 'datePicker'" :value="citem.value" format="yyyy-MM-dd" @on-change="zhidingriqiChanged(index,$event)" type="daterange" style="width: 432px" placement="bottom-end" :placeholder="citem.placeholder" :clearable="false">
            </DatePicker>
            <!-- <Input v-else v-model="citem.value" :placeholder="citem.placeholder" style="width: 280px;" search @on-search="change(index,$event)">
            </Input> -->
            <div v-else>
                <Input v-if="!citem.value || editing[citem.key]" :ref="'input:'+citem.key" v-model="inputing[citem.key]" icon="ios-search" :placeholder="citem.placeholder || ''" :style="`width:${citem.width || 280}px`" @on-enter="textChanged(citem,index)" @on-blur="textBlur(citem,index)">
                </Input>
                <div v-if="(!!citem.value) && !editing[citem.key]" @click="textEdit(citem,index)" class="jcsb nowrap" :style="`height: 32px;line-height: 32px;margin: 0;width: ${citem.width || 280}px;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;`">
                    <div>{{citem.value}}</div>
                    <Icon type="ios-close-circle" @click.stop="textClear(citem,index)"></Icon>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            dateSearh: { //是否需要时间筛选
                type: Boolean,
                default: false
            },
            selectList: {
                type: Array,
                default: () => []
            },
            searhForm: {
                type: Object,
                default: () => {}
            },
            columnsSearch: { //搜索配置
                type: Array,
                default: () => []
            }
        },
        computed: {
            column() {
                return this.columnsSearch
            }
        },
        // watch: {
        //     columnsSearch: {
        //         handler(val) {
        //             this.column = this.copy(val)
        //         },
        //         immediate: true,
        //         deep: true,
        //     }
        // },
        data() {
            return {
                inputing: {},
                editing: {},
                isDeleteButton: false,
                // column: [],
            }
        },
        methods: {
            textBlur(item, index) {
                if (this.inputing[item.key] != item.value) {
                    this.textChanged(item, index)
                }
            },
            textChanged(item, index) {
                item.value = this.inputing[item.key]
                this.columnsSearch[index].value = item.value
                this.$set(this.editing, item.key, false)
                this.change(index, item.value)
            },
            textEdit(item) {
                this.$set(this.editing, item.key, true)
                setTimeout(() => {
                    let input = this.$refs[`input:${item.key}`][0]
                    if (input) input.focus()
                }, 200)
            },
            textClear(item, index) {
                item.value = ''
                this.inputing[item.key] = ''
                this.$set(this.editing, item.key, true)
                setTimeout(() => {
                    let input = this.$refs[`input:${item.key}`][0]
                    if (input) input.focus()
                }, 200)
                this.columnsSearch[index].value = item.value
                this.change(index, item.value)
            },
            deleteButtonClick(index) {
                this.$nextTick(() => {
                    this.column[index].value = []
                    this.isDeleteButton = false
                })
            },
            selectChange(index, val, ) {
                let citem = this.column[index]
                let { key, field } = citem
                if (citem.multiple || citem.multi) {
                    if (val && field) {
                        val = citem.options.filter(o => val.some(s => s == (o.value || o.name || o._id || o)))
                        this.columnsSearch[index].value = val.map(o => o[field])
                    } else {
                        this.columnsSearch[index].value = val
                    }
                } else {
                    if (val && field) {
                        val = citem.options.find(o => val == (o.value || o.name || o._id || o))
                        val = val ? val[field] : null
                    }
                }
                this.$emit("change", {
                    [key]: val })
                if (citem.change) {
                    citem.change({ key, field, val })
                }
            },
            searchChange(index, val, local) {
                let { key, field, options } = this.column[index]
                if (this.column[index].change) {
                    this.column[index].change({ key, field, val })
                }
                let keywords = ''
                if (options.multiple || options.multi) { //此处为多选
                    let list = []
                    if (val) {
                        if (key == 'chukuleixings' || key == 'tongjileixings' || key == 'leixings' || key == 'rukuleixings' || key == 'yuanyins') {
                            list = val.map(el => el.name)
                        } else {
                            val.forEach(i => {
                                const item = { _id: i._id, code: i.code }
                                if (options.preserveName) item.name = i.name
                                list.push(item)
                            })
                        }
                    }
                    this.$emit("change", {
                        [key]: list
                    }, local)
                } else {
                    if (val && field) {
                        keywords = val[field]
                    } else if (val && val.name) {
                        keywords = val.name
                    }
                    this.$emit("change", {
                        [key]: keywords
                    }, local)
                }
            },
            change(index) {
                let { key, value } = this.column[index]
                this.$emit("change", {
                    [key]: value
                })
            },
            zhidingriqiChanged(index, val) {
                let { key } = this.column[index]
                this.$emit("change", {
                    [key]: val
                })
            }
        }
    }
</script>
<style lang="less">
    .search-form {
        display: flex;
        flex-wrap: wrap;
    }

    .box {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-right: 10px;
    }

    .delete-selected-mu {
        position: absolute;
        right: 8px;
        top: 6px;
        color: "#5C6B77";
        cursor: pointer;
        z-index: 99
    }
</style>



// WEBPACK FOOTER //
// src/components/common/Searching/index.vue?6316aa02